import React from 'react';
import TrendChartPage from './TrendChartPage';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../../actions/report.actions';
import Loading from '../../../Helpers/Loading';
import Backend from '../../../Layouts/Backend';
import lookupActions from '../../../../actions/lookup.actions';
import helper from '../../../../utils/helper';
import Moment from 'moment';

const TrendChart = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [isFetchingReport, updateIsFetchingReportFlag] = React.useState(false);
  const [groups, setGroups] = React.useState([]);
  const [errors, setErrors] = React.useState([]);
  const [form, setForm] = React.useState({
    groupId: undefined,
    sensorIds: '',
    fromDate: Moment().startOf('month').toDate(),
    toDate: new Date(),
  });
  async function fetchGroups() {
    setLoading(true);
    await props.reportActions.clearReport();
    props.lookupActions
      .getGroups()
      .then((resp) => setGroups(resp.items))
      .finally(() => setLoading(false));
  }
  React.useEffect(() => {
    fetchGroups();
  }, []);

  React.useEffect(() => {
    updateIsFetchingReportFlag(props.report.isFetching);
  }, [props.report.isFetching]);

  React.useEffect(() => {
    setErrors(
      helper.centralizeError([props.lookup.errors, props.report.error]),
    );
  }, [props.lookup.errors, props.report.error]);

  const onRunReport = (values) => {
    const locale = localStorage.getItem('language') || 'en_US';
    props.history.push(
      `/trend-charts${helper.compileQueryString(values)}&locale=${locale}`,
    );
  };

  if (loading)
    return (
      <Backend>
        <Loading />
      </Backend>
    );
  return (
    <TrendChartPage
      location={props.location}
      history={props.history}
      isFetchingReport={isFetchingReport}
      form={form}
      groups={groups}
      onRunReport={onRunReport}
      errors={errors}
    />
  );
};

function mapStateToProps(state) {
  return {
    lookup: state.lookup,
    report: state.report,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    reportActions: bindActionCreators(
      Object.assign({}, reportActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrendChart);
